import React from 'react'
import { Badge, type BadgeProps } from '@mantine/core'

export type AppBadgeProps = BadgeProps

/** Standard badge with sm radius. */
export default function AppBadge ({ radius = 'sm', ...props }: AppBadgeProps) {
  return <Badge radius={radius} {...props} />
}
